<template>
  <v-form @submit.prevent="submit">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Unternehmensanmeldung - Auswahl
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!--<alert />-->
            <v-text-field
              v-model="tenantLoginIdentifier"
              type="text"
              label="Mandantennummer"
              :disabled="loading"
              :error-messages="errorMessages"
            />
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    type="submit"
                    :disabled="loading"
                    :loading="loading"
                  >
                    Mandantennummer prüfen
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    block
                    color="primary"
                    exact
                    outlined
                    :to="{name: 'login'}"
                  >
                    Zurück zur normalen Anmeldung
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      untouched: true,
      loading: false,
      internalTenantLoginIdentifier: '',
      errorMessages: [],
    }
  },
  computed: {
    tenantLoginIdentifier: {
      get () {
        if (this.untouched) {
          return this.loginTenant
        } else {
          return this.internalTenantLoginIdentifier
        }
      },
      set (value) {
        this.untouched = false
        this.internalTenantLoginIdentifier = value
      },
    },
    ...mapGetters(['loginTenant']),
  },
  methods: {
    async submit () {
      this.loading = true
      this.errorMessages.splice(0, this.errorMessages.length)
      try {
        const result = await this.checkLoginTenant({
          tenantLoginIdentifier: this.tenantLoginIdentifier,
        })
        if (result.success) {
          this.$router.push({
            name: 'login-tenant',
            params: {loginIdentifier: this.tenantLoginIdentifier},
          })
        } else {
          this.errorMessages.splice(0, this.errorMessages.length, ...result.errors)
        }
      } finally {
        this.loading = false
      }
    },
    ...mapActions(['checkLoginTenant']),
  },
}
</script>
